import { render, staticRenderFns } from "./HasMany.vue?vue&type=template&id=29807e24&scoped=true&"
import script from "./HasMany.vue?vue&type=script&lang=js&"
export * from "./HasMany.vue?vue&type=script&lang=js&"
import style0 from "./HasMany.vue?vue&type=style&index=0&id=29807e24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29807e24",
  null
  
)

export default component.exports